// This helper function makes sure that string values such as "0" are still parsed as a number, returns null for empty strings.
export const numberOrNull = (value: string | number | null | undefined, map?: (value: number) => number) => {
	const number = value != null && String(value) !== "" && !isNaN(Number(value)) ? Number(value) : null;

	if (number && map) {
		return map(number);
	}

	return number;
};

export const round = (n: number, precision?: number): number => {
	precision = precision ?? 2;
	return Math.round(n * 10 ** precision) / (10 ** precision);
};
